import { RootState } from '@app/store';
import { ILiveEvent } from '@features/live/api/liveApi.type';
import lodashFindIndex from 'lodash/findIndex';
import lodashGroupBy from 'lodash/groupBy';
import lodashOrderBy from 'lodash/orderBy';

export const filterLiveEvents = (sportAlias?: string) => (state: RootState) => {
  const { events, showFavorites, favorites } = state.live;

  if (sportAlias === 'top') {
    const ids = new Set(events.filter((event) => event.show).map((event) => event.id));
    return Array.from(new Set(state.live.topEventIds)).filter((id) => ids.has(id));
  }

  const sortedEvents = [ ...events ].sort((a, b) => {
    const ap = a.position2 ?? { groupPosition: 1000, position: 1000 };
    const bp = b.position2 ?? { groupPosition: 1000, position: 1000 };
    if (ap.groupPosition !== bp.groupPosition) {
      return ap.groupPosition - bp.groupPosition;
    }
    return ap.position - bp.position;
  });
  const filteredEvents = sortedEvents.filter((event) => {
    if (!event.show || (showFavorites && !favorites.includes(event.id))) {
      return false;
    }
    if (sportAlias) {
      return event.alias === sportAlias;
    }
    return true;
  });
  return filteredEvents.map((item) => item.id);
};
export const selectLiveEventById = (eventId: number) => (state: RootState) => {
  if (!isNaN(eventId)) {
    return state.live.events.find((event) => event.id === eventId);
  }
};

export const selectAllLiveEvent = () => (state: RootState) => {
  return state.live;
};
export const liveEventInFavorites = (eventId: number) => (state: RootState) => {
  return state.live.favorites.includes(eventId);
};
export const selectLiveTopCount = (state: RootState) => state.live.topEventIds.length;
export const sortLiveEvents = (events: ILiveEvent[]) => {
  const positioned = events.filter((event) => typeof event?.position2?.groupId === 'number');
  const unpositioned = events.filter((event) => typeof event?.position2?.groupId !== 'number');
  const grouped = lodashGroupBy(lodashOrderBy(positioned, 'position2.position'), 'position2.groupId');

  const aliases = positioned.reduce((acc, item) => {
    const gid = item.position2.groupId;
    const gpos = item.position2.groupPosition;
    if (lodashFindIndex(acc, ['id', gid]) === -1) {
      acc.push({ id: gid, position: gpos ?? Number.POSITIVE_INFINITY });
    }
    return acc;
  }, [] as { id: number; position: number }[]);
  const sorted = lodashOrderBy(aliases, 'position')
    .reduce((result: ILiveEvent[], item) => {
      if (item.id in grouped) {
        result.push(...grouped[item.id]);
      }
      return result;
    }, []);
  return [ ...sorted, ...unpositioned ];
};
